import { DebtorSelect } from 'components/DebtorSelect';

import { useExternalMailActionFormContext } from './form-context';

export const ExternalMailActionDebtor = () => {
  const form = useExternalMailActionFormContext();

  return (
    <DebtorSelect
      value={form.values.debtorId}
      onChange={(debtorId, debtor) => {
        form.setFieldValue('debtorId', debtorId);
        form.setFieldValue('debtor', debtor ? { id: debtor.id, fullName: debtor.fullName } : null);
      }}
    />
  );
};
